import React, { useState } from 'react'
import CheckBoxLine from './CheckBoxLine'
import { FilterTypes } from 'models'

const BranchContainer = props => {
  const {
    object, subObjectLevel = 0,
    store, selectedObjects, setFilterProp,
    filterType
  } = props

  const [expanded, setExpanded] = useState(false)

  const childPropertyName = store === 'projects' ? 'children' : 'products'
  const renderSubObjects = () => {
    if (!object[childPropertyName] || !object[childPropertyName].length) return null

    return object[childPropertyName].map(obj =>
      <BranchContainer
        key={obj.id}
        object={obj}
        subObjectLevel={subObjectLevel + 1}
        selectedObjects={selectedObjects}
        store={store}
        setFilterProp={setFilterProp}
        filterType={filterType}
      />
    )
  }

  const isBranchExpandable = () => {
    if (object.id === 'all') return true

    if (filterType.toLowerCase() === FilterTypes.BRANDS.toLowerCase()) return false

    return object[childPropertyName] &&
      object[childPropertyName].length > 0
  }

  return (
    <div>
      <CheckBoxLine
        store={store}
        object={object}
        selectedObjects={selectedObjects}
        filterType={filterType}
        setFilterProp={setFilterProp}
        subObjectLevel={subObjectLevel}
        expandable={isBranchExpandable()}
        expanded={expanded}
        onClick={() => setExpanded(!expanded)}
        childPropertyName={childPropertyName}
      />
      {expanded && renderSubObjects()}
    </div>
  )
}

export default BranchContainer
